import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Neighbour } from "../../models";
import { BlockBody } from "../../../common/block-body/BlockBody";

type Props = {
  neighbours: Neighbour[];
};

export const NeighbourImage: FC<Props> = ({ neighbours }) => (
  <div
    className={classNames(
      "mt-20 flex w-full flex-col gap-20 px-5",
      "md:gap-15 md:px-16",
      "lg:mt-25 lg:flex-row lg:justify-center",
      "xl:max-w-container-wide xl:mx-auto xl:mt-40 xl:gap-20 xl:px-24",
    )}
  >
    {neighbours.map((neighbour) => (
      <div
        key={neighbour._uid}
        className={classNames(
          "flex flex-col gap-y-5",
          "md:flex-row md:items-center",
          "md:gap-x-7 md:gap-y-0",
          "lg:basis-1/2",
          "xl:gap-x-12",
        )}
      >
        <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
          <GatsbyImage
            image={getGatsbyImage(neighbour.image.filename, {
              layout: "fullWidth",
            })}
            alt={neighbour.image.alt}
            className={classNames(
              "aspect-square w-full rounded-lg",
              "md:w-[160px]",
              "xl:w-[200px]",
            )}
          />
          <div
            className={classNames(
              "text-regular text-base-400",
              "md:text-extra-small",
              "xl:text-regular",
            )}
          >
            <BlockBody richText={neighbour.text} />
          </div>
        </Fade>
      </div>
    ))}
  </div>
);
